// removed by extract-text-webpack-plugin
module.exports = {"report":"qempo_Purchased_report-b9Pu-yW"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/order/Purchase/purchased/components/Purchased.scss
// module id = 1857
// module chunks = 0